export const NAV_LINKS = [
  { name: 'nav.home', path: '/' },
  { name: 'nav.menu', path: '/menu' },
  { name: 'nav.reservations', path: '/reservations' },
  { name: 'nav.order', path: '/order' },
  { name: 'nav.about', path: '/about' },
  { name: 'nav.reviews', path: '/reviews' },
  { name: 'nav.contact', path: '/contact' },
];
